<template>
  <div ref="target" class="w-full h-full relative">
    <div class="absolute top-0 start-0 z-40 flex flex-col gap-y-2 p-4">
      <span class="text-4xl font-medium text-primary">
        {{ (index + 1).toString().padStart(2, '0') }}
      </span>
      <span class="text-xl">{{ $t(titles[index]) }}</span>
    </div>
    <div
      class="w-full h-full pb-3 z-30 absolute top-0 start-0 bg-slate-50/60 touch-none pointer-events-none"
    ></div>
    <div
      :style="{ backgroundImage: `url(${images[index]})` }"
      class="w-full h-full bg-center bg-no-repeat bg-cover"
    ></div>
    <Transition name="fade" mode="out-in">
      <div
        v-if="!isOutside"
        class="absolute top-0 start-0 w-full h-full flex flex-col pb-2 bg-slate-100"
      >
        <div class="flex flex-col gap-y-2 p-4">
          <span class="text-4xl font-medium text-primary">
            {{ (index + 1).toString().padStart(2, '0') }}
          </span>
          <span class="text-xl">{{ $t(titles[index]) }}</span>
        </div>
        <p v-html="descriptions[index]" class="px-4 pb-2 text-sm h-[inherit] overflow-y-auto"></p>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useMouseInElement } from '@vueuse/core'
import uae_citizens from '@/assets/pngs/smart_services/uae_citizens.png'
import uae_residents from '@/assets/pngs/smart_services/uae_residents.png'
import gcc_citizens from '@/assets/pngs/smart_services/gcc_citizens.png'
import visitors from '@/assets/pngs/smart_services/visitors.png'
import gcc_residents from '@/assets/pngs/smart_services/gcc_residents.png'
import establishments from '@/assets/pngs/smart_services/establishments.png'
import typing_centers from '@/assets/pngs/smart_services/typing_centers.png'
import { useI18n } from 'vue-i18n'

const target = ref(null)
const i18n = useI18n()

const { isOutside } = useMouseInElement(target)

defineProps({
  index: Number
})

const titles = [
  'individualPublicNote2',
  'individualPublicNote3',
  'individualPublicNote4',
  'individualPublicNote6',
  'individualPublicNote5',
  'establishmentPublicTitleLbl',
  'tcPublicTitleLbl'
]

const images = [
  uae_citizens,
  uae_residents,
  gcc_citizens,
  visitors,
  gcc_residents,
  establishments,
  typing_centers
]

const descriptions = computed(() => {
  return [
    i18n.t('individualPublicNote7'),
    i18n.t('individualPublicNote8'),
    i18n.t('individualPublicNote9'),
    i18n.t('individualPublicNote11'),
    i18n.t('individualPublicNote10'),
    `<ul class='list-disc ps-3'>
      <li class='py-0.5'>${i18n.t('establishmentPublicNote1')}</li>
      <li class='py-0.5'>${i18n.t('establishmentPublicNote2')}</li>
      <li class='py-0.5'>${i18n.t('establishmentPublicNote3')}</li>
      <li class='py-0.5'>${i18n.t('establishmentPublicNote1')}</li>
      <li class='py-0.5'>${i18n.t('establishmentPublicNote1')}</li>
      <li class='py-0.5'>
          <span class='text-primary-700 font-semibold'>${i18n.t('establishmentPublicNote4')}</span>
          <ul class='list-disc ps-6'>
              <li class='py-0.5'>${i18n.t('establishmentPublicNote5')}</li>
          </ul>
      </li>
      <li class='py-0.5'>
          <span class='text-primary-700 font-semibold'>${i18n.t('establishmentPublicNote6')}</span>
          <ul class='list-disc ps-6'>
              <li class='py-0.5'>${i18n.t('establishmentPublicNote7')}</li>
          </ul>
      </li>
    </ul>`,
    `
  <div class="flex flex-col gap-y-2">
    <span class='font-bold'>${i18n.t('typingCenterServicesPoint1')}</span>
    <ul class='list-disc ps-3'>
      <li class='py-0.5'>${i18n.t('typingCenterServicesPoint2')}</li>
      <li class='py-0.5'>${i18n.t('typingCenterServicesPoint3')}</li>
      <li class='py-0.5'>${i18n.t('typingCenterServicesPoint4')}</li>
      <li class='py-0.5'>${i18n.t('typingCenterServicesPoint5')}</li>
      <li class='py-0.5'>${i18n.t('typingCenterServicesPoint6')}</li>
    </ul>
  </div>
  `
  ]
})
</script>

<style lang="scss" scoped>

</style>
